//import React, { useState } from 'react';
import axios from 'axios';
//import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import {
    MDBContainer,
    MDBInput,
    //MDBBtn,
} from 'mdb-react-ui-kit';
import { useState, useContext} from 'react';
import ProductContext from '../context/ProductContext';



function LoginPage() {
    const productCtx = useContext(ProductContext);
    const {
      login,
      setLogin
    } = productCtx;

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const history = useNavigate();

    

    const handleLogin = async () => {
        try {
            if (!username || !password) {
                setError('Please enter both username and password.');
                return;
            }
            const apiUrl = process.env.REACT_APP_API_URL;
            // const response = await axios.post('http://muvitapp.com:8080/users/login', { username, password });
            const response = await axios.post('http://muvitapp.com/webapp1/', { username, password });
            console.log('Login successful with JWT token granted:', response.data);
            
            
            if (response.data) {
                
                sessionStorage.setItem('jwtToken', response.data);
                console.log('JWT token saved');
                sessionStorage.setItem('sessionusername', username);
                console.log('sesssion username: ', username);
                setLogin(true);
              } else {
                console.log('Login failed');
              }
            
               
           // history('/dashboard');
           history('/dashboard');

        } catch (error) {
            // console.error('Login failed:', error.response ? error.response.data : error.message);
            // setError('Invalid username or password.');
            console.error('Login failed:', error);
            if (error.response) {
            // Check if the server returned an error message
            console.log(error.response.data)
            setError(error.response.data.message || 'Invalid username or password.'); 
            } else if (error.message === 'Network Error') {
            // Handle the network error case
            setError('Login failed: Network Error');
            } else {
                // Handle other types of errors
                setError("Login failed: Unknown error")
            }
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="border rounded-lg p-4" style={{ width: '500px', height: 'auto' }}>
                <MDBContainer className="p-3">
                    <h2 className="mb-4 text-center">Login Page</h2>
                    <MDBInput wrapperClass='mb-4' placeholder='Username' id='email' value={username} type='email' onChange={(e) => setUsername(e.target.value)} />
                    <MDBInput wrapperClass='mb-4' placeholder='Password' id='password' type='password' value={password} onChange={(e) => setPassword(e.target.value)} />
                    {error && <p className="text-danger">{error}</p>} {/* Render error message if exists */}
                    <button className="mb-4 d-block btn-primary" style={{ height:'50px',width: '100%' }} onClick={handleLogin}>Sign in</button>
                    <div className="text-center">
                        <p>Not a member? <a href="/signup" >Register</a></p>
                    </div>
                </MDBContainer>
            </div>
        </div>
    );
}

export default LoginPage;